import en from '../en.json';
import de from '../de.json';
import { useUserContext } from './UserContextProvider';

// Destructuring the prop would read the key once at creation, so a caller whose key
// depends on a signal rendered the first key forever.
export default function Text(props: { val: string }) {

    const userContext = useUserContext();

    const value = () => userContext.user().language.values[props.val];
    return <span innerHTML={value() ?? props.val}></span>;
}

export function changeLanguage(lang: "en" | "de", user: any, setUser: any) {
    setUser({ ...(user()), language: lang === "en" ? en : de });
}